import React, { useContext } from "react";
import {
    Button,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import ContentContext from "../../../common/context/ContentContext";
import { useNavigate } from "react-router-dom";
import { SizeAwareComponent } from "../../../store/types";

interface OwnProps extends SizeAwareComponent {
    onCloseWithAutosave?: () => void;
};

const CloseButton = ({
    onCloseWithAutosave,
    isMinimumSize
}: OwnProps) => {
    const content = useContext(ContentContext);
    const navigate = useNavigate();
    return <Button
        onClick={() => {
            onCloseWithAutosave
                ? onCloseWithAutosave()
                : navigate(
                    `/subjects/${content!.subject}/contents`
                );
        }}
        variant={isMinimumSize ? "outline" : "ghost"}
        padding={isMinimumSize ? undefined : 0}
        margin={isMinimumSize ? undefined : 0}
        minWidth={isMinimumSize ? undefined : "5"}
        title="Close"
    >
        <FontAwesomeIcon icon={faClose} />
    </Button>
};

export default CloseButton;
